import { withAnalytics } from 'components/common/analytics';
import { SelectCarrier } from 'components/sign-up/components/phone-number/port-number/select-carrier';
import { compose } from 'redux';

const enhance = compose(withAnalytics);
const SelectCarrierContainer = enhance(SelectCarrier);

export { SelectCarrierContainer };
